import React from "react";
import { Phone, ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta"
      className="relative border-b border-[var(--c4p-line)] bg-[var(--c4p-cream)] py-20 lg:py-28"
    >
      <div className="mx-auto max-w-5xl px-6 text-center lg:px-10">
        <span className="eyebrow">One call is all it takes</span>
        <h2 className="font-display mx-auto mt-5 max-w-3xl text-[44px] leading-[1.02] sm:text-[60px] lg:text-[76px]">
          Ready for a fair offer, or just a{" "}
          <span className="font-display-italic text-[var(--c4p-orange)]">straight answer?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-sans-ui text-[16px] leading-relaxed text-[var(--c4p-muted)]">
          We'll talk through your situation — no scripts, no pressure. If we're
          not the right fit, we'll tell you who is.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="#lead"
            data-testid="final-cta-offer-btn"
            className="btn-primary"
          >
            Get My Cash Offer <ArrowRight size={16} />
          </a>
          <a
            href="tel:+19102125006"
            data-testid="final-cta-call-btn"
            className="btn-ghost inline-flex items-center gap-2"
          >
            <Phone size={14} /> Call (910) 212-5006
          </a>
        </div>
      </div>
    </section>
  );
}
